import React, { useContext, useEffect } from 'react';
import { translations } from 'src/constants/translations';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import {
  UnitsDataContext,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/context/UnitsDataProvider';
import {
  useStyles as mainUseStyles,
} from 'src/components/profileComponents/Marketplace/components/Common/styles';
import { MarketplaceButton } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceButton';
import AddIcon from '@mui/icons-material/Add';
import {
  UnitsCardEntity,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/UnitsCard/components/UnitsCardEntity';
import { RandomInteger } from 'src/helpers/randomInteger';
import { IMarketplace } from 'src/components/profileComponents/Marketplace/types';
import { ReactSortable, Sortable, Store } from 'react-sortablejs';
import { useMarketplaces } from 'src/hooks/marketplace';
import { IMarketplaceLanguageObjects } from 'src/typings/marketplace';
import {
  isNeedToBeUpdated,
} from 'src/components/profileComponents/Marketplace/components/Common/helpers/PropertyValueChecker';
import { useStyles } from '../Common/styles';

export const UnitsCard: React.FC<{marketplace: IMarketplace | undefined}> = ({ marketplace }) => {
  const styles = useStyles();
  const context = useContext(UnitsDataContext);
  const mainStyles = mainUseStyles();
  const { requestMarketplaceLanguageObjects } = useMarketplaces();
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);
  const [rocketState, setRocketState] = React.useState<boolean>(!!context?.state.unitsCard.tag.isActive);
  const [allSelectedProperties, setAllSelectedProperties] = React.useState<IMarketplaceLanguageObjects>();

  useEffect(() => {
    if (marketplace) {
      const allSystemNames = marketplace?.frontConfiguration.module.placementTile.card.tag.elements
        .map((item) => item.property?.systemName || '')
        .filter((systemName) => systemName.length);
      requestMarketplaceLanguageObjects({
        marketplaceId: marketplace.id,
        findProperties: allSystemNames,
      }).then((res) => {
        setAllSelectedProperties(res.data);
      });
    }
  }, [marketplace]);

  const rocketChange = (state: boolean) => {
    if (context?.state.unitsOrder) {
      context.updateState((current) => ({
        ...current,
        unitsCard: { ...current.unitsCard, tag: { ...current.unitsCard.tag, isActive: state } },
      }));
      setRocketState(state);
    }
  };

  const moveToTrash = (index: number) => {
    if (context) {
      context.updateState((current) => ({
        ...current,
        unitsCard: {
          ...current.unitsCard,
          tag: {
            ...current.unitsCard.tag,
            elements: current.unitsCard.tag.elements.filter((_, itemIndex) => itemIndex !== index),
          },
        },
      }));
    }
  };

  const addTag = () => {
    if (context) {
      context.updateState((current) => ({
        ...current,
        unitsCard: {
          ...current.unitsCard,
          tag: {
            ...current.unitsCard.tag,
            elements: [...current.unitsCard.tag.elements, {
              '@id': RandomInteger().toString(),
              iconFileUri: null,
              prefix: null,
              suffix: null,
              property: {
                diType: 'PlacementProperty',
                isUsedForNaming: false,
                oldSystemName: null,
                systemName: '',
                translates: null,
              },
              propertyValue: null,
              styles: {
                fontWeight: 'normal',
                textDecoration: 'none',
                color: '',
                backgroundColor: '',
                borderColor: '',
              },
            }],
          },
        },
      }));
    }
  };

  return (
    <>
      <GroupWrapper
        name={translations.unitsCardTags}
        customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            rocketState={rocketState}
            onRocket={rocketChange}
            onCollapse={(state) => {
              setCollapseState(state);
            }}
          />
          )}
      >
        { collapseState === GroupWrapperCollapseState.OPEN && (
        <div className={styles.wrapper}>
          <div className={styles.text}>
            { translations.AddAnotherUnitTag }
          </div>
          <div>
            <MarketplaceButton
              startIcon={<AddIcon />}
              label={translations.unitTag}
              onClick={() => addTag()}
            />
          </div>
        </div>
        ) }
      </GroupWrapper>
      {context && (
        <ReactSortable<any>
          className={mainStyles.iteratorWrapper}
          animation={150}
          handle=".drag-handle"
          list={context.state.unitsCard.tag.elements.map((el) => ({ ...el, chosen: false }))}
          setList={(newList, sortable: Sortable | null, store: Store) => {
            if (store && store.dragging && store.dragging.props
              && JSON.stringify(store.dragging.props.list) !== JSON.stringify(newList)) {
              context.updateState((current) => ({
                ...current,
                unitsCard: {
                  ...current.unitsCard,
                  tag: { ...current.unitsCard.tag, elements: newList },
                },
              }));
            }
          }}
        >
          { collapseState === GroupWrapperCollapseState.OPEN && allSelectedProperties && context.state.unitsCard.tag.elements.map((item, index) => (
            <React.Fragment key={item['@id']}>
              <UnitsCardEntity
                marketplace={marketplace}
                entity={item}
                onChange={(updatedItem) => context.updateState((current) => ({
                  ...current,
                  unitsCard: {
                    ...current.unitsCard,
                    tag: {
                      ...current.unitsCard.tag,
                      elements: current.unitsCard.tag.elements.map((element) => (
                        element['@id'] === updatedItem['@id'] ? updatedItem : element
                      )),
                    },
                  },
                }))}
                isNeedToBeUpdated={isNeedToBeUpdated(item.property.systemName, item.propertyValue, allSelectedProperties)}
                lang={context.state.marketplace.language}
                propertyOptions={context.state.placementPropertyOptions}
                moveToTrash={() => moveToTrash(index)}
              />
            </React.Fragment>
          )) }
        </ReactSortable>
      ) }
    </>
  );
};
